import { Inspection } from "../model/inspection";
import { InspectionState } from "../model/inspection-state";

export const EMPTY_INSPECTION: Inspection = {
  id: "id",
  templateId: "",
  operationTypeId: "",
  state: InspectionState.New,
  generalInfo: {
    id: "",
    originApplicationName: "Cotecna EYE",
    state: InspectionState.New,
    client: "",
    date: [],
    address: {
      text: "",
      longitude: null,
      latitude: null,
    },
    scopeOfWork: "",
    externalId: "",
    inspectionReference: "",
    additionalFields: [],
    availablePrefilledOthers: [],
    externalCoordinators: [],
  },
  scopeOfWork: {
    formId: "",
    showAsList: false,
    form: {
      sections: [],
      controls: [],
    },
    values: [],
    isCompleted: false,
  },
  users: [],
  itemsInfo: {
    items: [],
  },
  legalEntity: null,
  clientId: "",
  officeId: "",
  creationDate: new Date(),
  closeDate: null,
  documents: [],
  pictures: [],
  timelog: {
    events: [],
    options: [],
  },
  originApplicationName: "Cotecna EYE",
  presetId: "",
  presetName: "",
  externalCoordinators: [],
};
